import Vue from 'vue';
import Storage from '../services/Storage';

class UserStore {
    constructor() {
        // Pré-remplit le store réactif depuis le stockage local au chargement de la page
        this.user = Storage.get('user') || {};
        this.isLoggedIn = !!Storage.get('token');
    }
}

// Rend l'instance réactive pour Vue.js 2
const reactiveStore = Vue.observable(new UserStore());

export default reactiveStore;
